import { Box, Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { StyledAddToHomePageModal } from './style';
import { useEffect, useState } from 'react';
import androidLight from '../../../assets/android-light.png';
import androidDark from '../../../assets/android-dark.png';

interface AddToHomePageModalProps {
  publisherStoreLogo: string;
  publisherStoreName: string;
  isDarkMode: boolean;
  onClick: () => void;
  isAndroid?: boolean;
}

const Modal = ({
  publisherStoreLogo,
  publisherStoreName,
  isDarkMode,
  onClick,
  isAndroid = false,
}: AddToHomePageModalProps) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute(
      'data-theme',
      isDarkMode ? 'dark' : 'light',
    );
  }, [isDarkMode]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClick();
    }, 200);
  };

  return (
    <StyledAddToHomePageModal isClosing={isClosing} isAndroid={isAndroid}>
      <Box className="container">
        <IconButton className="close-button" onClick={handleClose}>
          <CloseIcon className="close-button--icon" />
        </IconButton>
        {!isAndroid && (
          <Box className="company-info">
            <Box>
              <img
                className="company-info--logo"
                alt="publisher-logo"
                src={publisherStoreLogo}
              />
              <h2 className="company-info--title">{publisherStoreName}</h2>
              <p className="company-info--description">
                Install {publisherStoreName} to get the latest deals!
              </p>
            </Box>
          </Box>
        )}
        <Box className="guide">
          {!isAndroid && (
            <>
              <Divider className="guide-divider" />
              <p className="guide-description">
                This site has app functionality. Add it to your Home Screen for
                extensive experience and easy access!
              </p>
              <Divider className="guide-divider" />
            </>
          )}
          <ul className="guide-list">
            <li className="guide-list--item">
              {isAndroid ? (
                <>
                  <i className="fa-solid fa-ellipsis-vertical guide-list--item__icon"></i>
                  1. Click on the more icon
                </>
              ) : (
                <>
                  <i className="fa-solid fa-arrow-up-from-bracket guide-list--item__icon"></i>
                  1. Click on the "Share" icon in the navigation bar
                </>
              )}
            </li>
            <li className="guide-list--item">
              {isAndroid ? (
                <img
                  src={isDarkMode ? androidDark : androidLight}
                  alt="icon"
                  className="guide-list--item__icon"
                  style={{ color: 'black' }}
                />
              ) : (
                <i className="fa-regular fa-square-plus guide-list--item__icon"></i>
              )}
              2. Click "Add to Home Screen"
            </li>
          </ul>
        </Box>
      </Box>
    </StyledAddToHomePageModal>
  );
};

export default Modal;
